import React from 'react';
export const GridContainerContext = /*#__PURE__*/React.createContext({
  edges: []
});